import { schema } from 'normalizr';

const clientInvitation = new schema.Entity('clientInvitation');
const clientInvitations = {
	content: [new schema.Entity('clientInvitations')]
};

const ClientInvitationSchemas = {
	CLIENT_INVITATIONS: clientInvitations,
	CLIENT_INVITATION: clientInvitation
};

export default ClientInvitationSchemas;
